projectFunctions.navigationFunctions = projectFunctions.navigationFunctions || {};

/**
 * Init: Will be triggered on document ready.
 */
projectFunctions.navigationFunctions.init = function() {
    this.navigate();
};

projectFunctions.navigationFunctions.navigate = function () {
    const menuItems = document.querySelectorAll('.shiftnav-target');
    const subMenus = document.querySelectorAll('.sub-menu');

    if (!menuItems) {
        return;
    }

    // To move menu forward and add back-btn to relevant sub-menus
    menuItems.forEach(item => {
        item.addEventListener('click', (e) => {
            let currentMenu = item.closest('ul');
            let liItem = item.closest('li');
            let nextSubMenu = liItem.querySelector('.sub-menu');
            let currentMenuItems = currentMenu.querySelectorAll(':scope > li');


            if (nextSubMenu && liItem.classList.contains('menu-item-has-children')) {
                e.preventDefault();
                currentMenuItems.forEach(item => {
                    item.classList.remove('active');

                    // This is because main menu li starts with position relative and left 0.
                    item.classList.add('not-active');
                });
                liItem.classList.remove('not-active');
                liItem.classList.add('active');
                currentMenu.classList.remove('current-sub-active');
                nextSubMenu.classList.add('current-sub-active');

                if (currentMenu.classList.contains('sub-menu')) {
                    currentMenu.classList.add('sub-active');
                }

                // Add back button if it hasn't been added already
                if (!nextSubMenu.querySelector('.back-btn-container')) {
                    nextSubMenu.insertAdjacentHTML('afterbegin', `
                        <li class="back-btn-container">
                          <button class="back-btn">
                            <img src="/wp-content/themes/mediastyle/assets/images/arrow_backward.svg" alt="Back arrow" style="width: 16px; height: 16px">
                            Back
                          </button>
                        </li>
                    `);
                }
            }
        });
    });

    // To move menu backwards
    // Since the back-btn is dynamically added, we use event delegation
    subMenus.forEach(subMenu => {
        subMenu.addEventListener('click', (e) => {
            let backBtn = e.target.closest('.back-btn');
            
            // If clicked element is back-btn or inside back-btn, move backwards
            if (backBtn) {
                let currentMenu = backBtn.closest('.sub-menu');
                let previousMenu = currentMenu.parentElement.closest('ul');
                let previousLiItems = previousMenu.querySelectorAll(':scope > li');
                currentMenu.classList.remove('current-sub-active');
                previousMenu.classList.remove('sub-active');
                previousMenu.classList.add('current-sub-active');
                previousLiItems.forEach(item => {
                    item.classList.remove('not-active');
                });
            }
        });
    });
};